import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { AppProviders } from '@/providers/AppProviders'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import './styles/index.css'
import './styles/mobile-layout.css'
import './styles/mobile-pages.css'
import './styles/tailwind.css'
import '@/pages/NotFound.css'
import { cleanupServiceWorkersAndCaches } from '@/utils/service-worker-cleanup'

// Recuperación cuando falla la carga de un chunk (p. ej. tras un nuevo deploy)
function isChunkLoadRejection(reason: unknown): boolean {
  const msg = reason instanceof Error ? reason.message : String(reason ?? '')
  return (
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Loading chunk') ||
    msg.includes('ChunkLoadError')
  )
}

window.addEventListener('unhandledrejection', (event) => {
  if (!isChunkLoadRejection(event.reason)) return
  event.preventDefault()
  cleanupServiceWorkersAndCaches().then(() => {
    window.location.reload()
  })
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <AppProviders>
          <App />
        </AppProviders>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
)
